import { ECHARTSCOLOR } from '@intelligence/utils/echartsConst';

/**
 * 网格配置（带顶部标签）
 * containLabel: true 确保Y轴标签不被裁剪
 */
export const LINE_GRID_WITH_LABEL = {
  left: 10,
  right: 10,
  top: 20,
  bottom: 40,
  containLabel: true,
};

/**
 * 图例间距
 */
export const LINE_LEGEND_ITEM_GAP = 18;

/**
 * echarts折线图静态配置
 */
export const LINE_CHART_STATIC_OPTION: any = {
  color: ECHARTSCOLOR,
  title: {
    show: false,
  },
  tooltip: {
    trigger: 'axis',
    padding: 0,
    borderWidth: 0,
    formatter: void 0,
  },
  legend: {
    type: 'scroll',
    orient: 'horizontal',
    pageIconColor: '#000',
    selectedMode: true,
    pageIconSize: 12,
    pageTextStyle: {
      color: '#000',
    },
    show: true,
    icon: 'circle',
    itemWidth: 20,
    itemHeight: 10,
    bottom: 0,
    left: 'center',
    itemGap: LINE_LEGEND_ITEM_GAP,
    itemStyle: {
      opacity: 1,
    },
    textStyle: {
      padding: [0, 0, 0, -7],
      color: '#888888',
      fontSize: 12,
    },
    formatter: void 0,
  },
  grid: LINE_GRID_WITH_LABEL,
  xAxis: [
    {
      type: 'category',
      boundaryGap: true,
      axisLine: {
        color: 'rgba(0,0,0,0.45)',
      },
      axisTick: {
        alignWithLabel: true,
      },
      data: [],
    },
  ],
  yAxis: [
    {
      type: 'value',
      axisLine: {
        show: false,
      },
      axisLabel: {
        color: 'rgba(0,0,0,0.45)',
        formatter: void 0,
      },
      axisTick: {
        show: false,
      },
      splitLine: {
        lineStyle: {
          color: '#E9E9E9',
        },
      },
    },
  ],
  series: [],
};
